/**
 * @generated SignedSource<<1bd4177ba4d2c6eb83cf06601bdc5f24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StartContentConfigType = "StartContent_CanIfInTreeFlow" | "StartContent_CanNot" | "StartContent_SpecificUserStatusesCan" | "%future added value";
export type UserStatus = "active" | "activeEfnNeeded" | "changeInProgress" | "doccheck" | "doctorWithEfnInitialValidation" | "efnNeeded" | "inactive" | "initialValidation" | "noProcess" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment$data = {
  readonly configType?: StartContentConfigType;
  readonly dateTime?: string | null | undefined;
  readonly id?: string;
  readonly requiredUserStatuses?: ReadonlyArray<UserStatus>;
  readonly " $fragmentType": "SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment";
};
export type SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment$key = {
  readonly " $data"?: SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "configType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiredUserStatuses",
          "storageKey": null
        }
      ],
      "type": "SpecifiedUserStatusesCanStartContentConfig",
      "abstractKey": null
    }
  ],
  "type": "StartContentConfig",
  "abstractKey": "__isStartContentConfig"
};

(node as any).hash = "a0a155d8a5856c14236700fd7ba92147";

export default node;
